import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, Col, Form, InputGroup, Row, Spinner } from 'react-bootstrap';

import { useToast } from 'context/providers/ToastProvider';
import GastoCard from './GastoCard';
import ModalDescargaNotaVenta from './ModalDescargaNotaVenta';
import { ModalRegistroGastoRefactor } from './modal-registro-gasto';
import ModalVisualizarDetallesGasto from './modal-registro-gasto/ModalVisualizarDetallesGasto';

const ListaGastos = (
    {
        setShowModalNuevo,
        showModalNuevo,

        setShowModalRegistrarGasto,
        showModalRegistrarGasto
    }

) => {

    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();

    const [copia, setCopia] = useState(false);
    const [Editar, setEditar] = useState(false);

    const [gastos, setGastos] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [busqueda, setBusqueda] = useState('');
    const [selectedGasto, setSelectedGasto] = useState({});
    const [ultimoGasto, setUltimoGasto] = useState(null);
    const [showDescargaModal, setShowDescargaModal] = useState(false);
    const [showVisualizarModal, setShowVisualizarModal] = useState(false);

    // Estado para gastos seleccionados
    const [gastosSeleccionados, setGastosSeleccionados] = useState([]);

    // Estados para rango de fechas
    const [fechaInicio, setFechaInicio] = useState(() => {
        const date = new Date();
        return new Date(date.getFullYear(), date.getMonth(), 1); // Primer d�a del mes actual
    });
    const [fechaFin, setFechaFin] = useState(() => {
        const date = new Date();
        return new Date(date.getFullYear(), date.getMonth() + 1, 0); // �ltimo d�a del mes actual
    });

    // Estados para infinite scroll
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize] = useState(20); // N�mero de elementos por p�gina
    const [hasMoreData, setHasMoreData] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalSum, setTotalSum] = useState(0);

    // Estados para filtros adicionales
    const [tipoGastoFilter, setTipoGastoFilter] = useState('');
    const [tiposGasto, setTiposGasto] = useState([]);
    const [formaPagoFilter, setFormaPagoFilter] = useState('');
    const [formasPago, setFormasPago] = useState([]);
    const [cuentaBancariaFilter, setCuentaBancariaFilter] = useState('');
    const [cuentasBancarias, setCuentasBancarias] = useState([]);

    /**
    * Se ejecuta la primera vez
    */
    useEffect(() => {
        ObtenerDatosGastos()
        ObtenerTiposGasto();
        ObtenerFormasPago();
        ObtenerCuentasBancarias();
    }, []);


    /**
    * Obtiene los Formas Pago
    */
    const ObtenerGastoDetalle = async (id) => {


        //setCargando(true);

        var objDataSend = {};

        objDataSend.idGasto = id;

        console.log(objDataSend, 'ID DEL PRODUCTO');
        var jDataSend = JSON.stringify(objDataSend);


        const response = await fetch("/api/Gastos/ObtenerGastoDetalle", {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: jDataSend
        })

        if (response.ok) {
        //    setCargando(false);

            console.log("==== OBTENER GASTO SELECCIONADO ====");

            console.log("response: ", response);
            const data = await response.json();
            console.log("dataRF: ", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                console.log("ObjDetallesGASTO:", ObjDetalles);

                let datosGastos = ObjDetalles.table2[0]
                console.log("datos:", datosGastos);

                if (datosGastos.vNotaVenta_Name) {
                    // Solo se ejecuta si existe `vNotaVenta_Name`
                    var file_Nota = base64ToFile(datosGastos.vNotaVenta_Base64, datosGastos.vNotaVenta_Name);

                    let datoGasto_ = { ...datosGastos }; // Crear copia para evitar mutaciones directas
                    datoGasto_.fileNota = file_Nota;

                    datoGasto_.idTipoMoneda = datosGastos.vMoneda === "MXN" ? 1 : datosGastos.vMoneda === "USD" ? 2 : null;
                    setSelectedGasto(datoGasto_);

                    console.log('ObjDetalles.table2:', ObjDetalles.table2);
                    console.log('Selected Gasto antes de asignar:', ObjDetalles.table2[0]);
                } else {
                    let datoGasto_ = { ...datosGastos }; // Crear copia para evitar mutaciones directas
                    datoGasto_.idTipoMoneda = datosGastos.vMoneda === "MXN" ? 1 : datosGastos.vMoneda === "USD" ? 2 : null;

                    setSelectedGasto(datoGasto_);
                }


            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
     * Efecto para obtener los datos de gastos cuando cambia el rango de fechas
     */
    useEffect(() => {
        if (fechaInicio && fechaFin) {
            setPageNumber(1);
            setHasMoreData(true);
            setGastos([]);
            ObtenerDatosGastos(1, false);
        }
    }, [fechaInicio, fechaFin]);

    /**
     * Efecto para obtener los datos de gastos cuando cambia el t&eacute;rmino de b&uacute;squeda
     * Implementa debounce para evitar m&uacute;ltiples peticiones
     */
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setPageNumber(1);
            setHasMoreData(true);
            setGastos([]);
            ObtenerDatosGastos(1, false);
        }, 500); // Espera 500ms despu&eacute;s de que el usuario deja de escribir

        return () => clearTimeout(timeoutId);
    }, [busqueda]);

    /**
     * Efecto para obtener los datos de gastos cuando cambia el filtro de tipo de gasto
     */
    useEffect(() => {
        setPageNumber(1);
        setHasMoreData(true);
        setGastos([]);
        ObtenerDatosGastos(1, false);
    }, [tipoGastoFilter]);

    /**
     * Efecto para obtener los datos de gastos cuando cambia el filtro de forma de pago
     */
    useEffect(() => {
        setPageNumber(1);
        setHasMoreData(true);
        setGastos([]);
        ObtenerDatosGastos(1, false);
    }, [formaPagoFilter]);

    /**
     * Efecto para obtener los datos de gastos cuando cambia el filtro de cuenta bancaria
     */
    useEffect(() => {
        setPageNumber(1);
        setHasMoreData(true);
        setGastos([]);
        ObtenerDatosGastos(1, false);
    }, [cuentaBancariaFilter]);

    /**
     * Convertir Base64 a archivo
     */
    const base64ToFile = (base64String, fileName) => {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/octet-stream' });

        return new File([blob], fileName, { type: blob.type });
    };

    /**
     * Obtiene los Datos de los Gastos con paginaci&oacute;n
     */
    const ObtenerDatosGastos = async (page = 1, append = false) => {
        if (!append) {
            setCargando(true);
        } else {
            setLoadingMore(true);
        }

        var objDataSend = {};

        // Formatear fechas en formato ISO (YYYY-MM-DD)
        objDataSend.fechaInicio = fechaInicio ? fechaInicio.toISOString().split('T')[0] : null;
        objDataSend.fechaFin = fechaFin ? fechaFin.toISOString().split('T')[0] : null;
        objDataSend.pageNumber = page;
        objDataSend.pageSize = pageSize;
        objDataSend.searchTerm = busqueda;
        objDataSend.idTipoGasto = tipoGastoFilter || null;
        objDataSend.idFormaPago = formaPagoFilter || null;
        objDataSend.idCuentaBancaria = cuentaBancariaFilter || null;

        console.log(objDataSend, 'Par�metros de b�squeda');
        var jDataSend = JSON.stringify(objDataSend);

        const response = await fetch("/api/Gastos/ObtenerDatosGastos", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: jDataSend
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            console.log("==== OBTENER DATOS GASTOS ====");

            const data = await response.json();

            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);
                console.log("obtenerDatosGastos", ObjDetalles.table2);

                const nuevosGastos = ObjDetalles.table2 || [];

                if (append) {
                    setGastos(prev => [...prev, ...nuevosGastos]);
                } else {
                    setGastos(nuevosGastos);
                    setPageNumber(1);
                }

                // Verificar si hay m�s datos disponibles
                const totalRecordsFromResponse = ObjDetalles.table3?.[0]?.totalRecords || 0;
                setTotalRecords(totalRecordsFromResponse);
                setHasMoreData((page * pageSize) < totalRecordsFromResponse);

                const totalSumFromResponse = ObjDetalles.table4?.[0]?.totalSum || 0;
                setTotalSum(totalSumFromResponse);

                const UltimoGasto = nuevosGastos.length > 0 ? nuevosGastos[0] : null;
                if (!append) {
                    setUltimoGasto(UltimoGasto ? {
                        idTipoGasto: UltimoGasto.idTipoGasto,
                        idCatFormaPago: UltimoGasto.idCatFormaPago,
                        vTipoFactorIva: UltimoGasto.vTipoFactorIva
                    } : null);
                }
            } else {
                showErrorToast(data.vMessage);
                if (!append) {
                    setGastos([]);
                    setHasMoreData(false);
                }
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            if (!append) {
                setGastos([]);
                setHasMoreData(false);
            }
        }

        if (!append) {
            setCargando(false);
        } else {
            setLoadingMore(false);
        }
    };

    /**
     * Funci&oacute;n para cargar m&aacute;s datos (infinite scroll)
     */
    const cargarMasDatos = () => {
        if (hasMoreData && !loadingMore && !cargando) {
            const nextPage = pageNumber + 1;
            setPageNumber(nextPage);
            ObtenerDatosGastos(nextPage, true);
        }
    };

    /**
     * Funci&oacute;n para obtener el icono correspondiente a la forma de pago
     */
    const getFormaPagoIcon = (formaPago) => {
        const formaPagoLower = formaPago?.toLowerCase() || '';//Obtiene el icono de la forma de pago

        if (formaPagoLower.includes('tarjeta') || formaPagoLower.includes('credito') || formaPagoLower.includes('debito')) {
            return <FontAwesomeIcon icon={icon({ name: 'credit-card', style: "solid" })} className="text-primary" />;
        } else if (formaPagoLower.includes('transferencia') || formaPagoLower.includes('banco') || formaPagoLower.includes('spei')) {
            return <FontAwesomeIcon icon={icon({ name: 'university', style: "solid" })} className="text-info" />;
        } else if (formaPagoLower.includes('efectivo') || formaPagoLower.includes('cash')) {
            return <FontAwesomeIcon icon={icon({ name: 'money-bill-wave', style: "solid" })} className="text-success" />;
        } else if (formaPagoLower.includes('cheque')) {
            return <FontAwesomeIcon icon={icon({ name: 'money-check', style: "solid" })} className="text-warning" />;
        } else {
            return <FontAwesomeIcon icon={icon({ name: 'wallet', style: "solid" })} className="text-secondary" />;
        }
    };

    /**
     * Manejadores para las acciones del GastoCard
     */
    const handleViewGasto = (idGasto) => {
        ObtenerGastoDetalle(idGasto);
        setShowVisualizarModal(true);
        setShowModalNuevo(false);
    };

    const handleEditGasto = (idGasto) => {
        ObtenerGastoDetalle(idGasto);
        setShowModalRegistrarGasto(true);
        setShowModalNuevo(false);
        setEditar(true);
    };

    const handleCopyGasto = (idGasto) => {
        ObtenerGastoDetalle(idGasto);
        setShowModalRegistrarGasto(true);
        setShowModalNuevo(false);
        setCopia(true);
        setEditar(true);
    };

    /**
     * Funci�n para descargar la nota de venta del gasto
     */
    const handleDescargarNotaVenta = async (idGasto) => {
        setShowDescargaModal(true);

        try {
            const response = await fetch(`/api/Gastos/ObtenerNotaVenta?idGasto=${idGasto}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType === 1) {
                    const detalles = JSON.parse(data.detalles);
                    const { vNotaVenta_Base64, vNotaVenta_Name } = detalles.table2[0];

                    // Convertir Base64 a Blob y descargar
                    const byteCharacters = atob(vNotaVenta_Base64);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = vNotaVenta_Name;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    URL.revokeObjectURL(link.href);
                } else {
                    showErrorToast(data.vMessage || 'Error al obtener nota de venta');
                }
            } else {
                showErrorToast('Error en la petici�n: ' + response.statusText);
            }
        } catch (error) {
            showErrorToast('Error al descargar nota de venta');
            console.error('Error al descargar nota de venta:', error);
        } finally {
            setShowDescargaModal(false);
        }
    };

    /**
     * Componente para el trigger de infinite scroll
     */
    const InfiniteScrollTrigger = () => {
        const triggerRef = React.useRef();

        React.useEffect(() => {
            const observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting && hasMoreData && !loadingMore && !cargando) {
                        cargarMasDatos();
                    }
                },
                { threshold: 0.1 }
            );

            if (triggerRef.current) {
                observer.observe(triggerRef.current);
            }

            return () => {
                if (triggerRef.current) {
                    observer.unobserve(triggerRef.current);
                }
            };
        }, [hasMoreData, loadingMore, cargando]);

        if (!hasMoreData) return null;

        return (
            <div ref={triggerRef} className="text-center py-4">
                {loadingMore ? (
                    <div>
                        <Spinner animation="border" variant="primary" className="mb-2" />
                        <div className="text-muted small">Cargando m&aacute;s gastos...</div>
                    </div>
                ) : (
                    <div className="text-muted small">Despl&aacute;zate para cargar m&aacute;s</div>
                )}
            </div>
        );
    };

    /**
     * Funci�n para alternar la selecci�n de un gasto
     */
    const toggleSeleccionGasto = (idGasto) => {
        setGastosSeleccionados(prev => {
            if (prev.includes(idGasto)) {
                return prev.filter(id => id !== idGasto);
            } else {
                return [...prev, idGasto];
            }
        });
    };

    /**
     * Obtiene los Tipos de Gasto
     */
    const ObtenerTiposGasto = async () => {
        const response = await fetch("/api/Gastos/obtenerTipoDeGasto", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        });

        if (response.ok) {
            const data = await response.json();
            if (data.iResponseType == 1) {
                const ObjDetalles = JSON.parse(data.detalles);
                setTiposGasto(ObjDetalles.table2 || []);
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
     * Obtiene las Formas de Pago
     */
    const ObtenerFormasPago = async () => {
        const response = await fetch("/api/Gastos/obtenerFormasdePago", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        });

        if (response.ok) {
            const data = await response.json();
            if (data.iResponseType == 1) {
                const ObjDetalles = JSON.parse(data.detalles);
                setFormasPago(ObjDetalles.table2 || []);
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
     * Obtiene las Cuentas Bancarias
     */
    const ObtenerCuentasBancarias = async () => {
        const response = await fetch("/api/Gastos/obtenerCuentasBancarias", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        });

        if (response.ok) {
            const data = await response.json();
            if (data.iResponseType == 1) {
                const ObjDetalles = JSON.parse(data.detalles);
                setCuentasBancarias(ObjDetalles.table2 || []);
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    return (
        <>
            <Row>
                <Col>
                    <Card className="mb-3">
                        <Card.Header className="bg-light">
                            <Row className="align-items-center">
                                <Col xs={12} md={6} lg={4}>
                                    <Form.Group>
                                        <Form.Label className="text-700 mb-1">Rango de Fechas</Form.Label>
                                        <div>
                                            <DatePicker
                                                selectsRange={true}
                                                startDate={fechaInicio}
                                                endDate={fechaFin}
                                                onChange={(update) => {
                                                    setFechaInicio(update[0]);
                                                    setFechaFin(update[1]);
                                                }}
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                                placeholderText="Selecciona un rango de fechas"
                                                isClearable={true}
                                            />
                                        </div>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6} lg={4}>
                                    <Form.Group>
                                        <Form.Label className="text-700 mb-1">Buscar gastos</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text>
                                                <FontAwesomeIcon icon={icon({ name: 'search', style: "solid" })} />
                                            </InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder="Buscar por descripci&oacute;n, responsable, tipo, forma de pago..."
                                                value={busqueda}
                                                onChange={(e) => setBusqueda(e.target.value)}
                                            />
                                            {busqueda && (
                                                <Button
                                                    variant="outline-secondary"
                                                    onClick={() => setBusqueda('')}
                                                >
                                                    <FontAwesomeIcon icon={icon({ name: 'times', style: "solid" })} />
                                                </Button>
                                            )}
                                        </InputGroup>
                                    </Form.Group>
                                </Col>

                            </Row>
                        <Row className="align-items-center mt-2">
                            <Col xs={12} md={4} lg={4}>
                                <Form.Group>
                                    <Form.Label className="text-700 mb-1">Tipo de Gasto</Form.Label>
                                    <Form.Select
                                        value={tipoGastoFilter}
                                        onChange={(e) => setTipoGastoFilter(e.target.value)}
                                        className="form-select"
                                    >
                                        <option value="">Todos</option>
                                        {tiposGasto.map((tipo) => (
                                            <option key={tipo.idTipoGasto} value={tipo.idTipoGasto}>
                                                {tipo.vNombre}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={4} lg={4}>
                                <Form.Group>
                                    <Form.Label className="text-700 mb-1">Forma de Pago</Form.Label>
                                    <Form.Select
                                        value={formaPagoFilter}
                                        onChange={(e) => setFormaPagoFilter(e.target.value)}
                                        className="form-select"
                                    >
                                        <option value="">Todas</option>
                                        {formasPago.map((pago) => (
                                            <option key={pago.idCatFormaPago} value={pago.idCatFormaPago}>
                                                {pago.vClave} - {pago.vDescripcionFormaPago}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={4} lg={4}>
                                <Form.Group>
                                    <Form.Label className="text-700 mb-1">Cuenta Bancaria</Form.Label>
                                    <Form.Select
                                        value={cuentaBancariaFilter}
                                        onChange={(e) => setCuentaBancariaFilter(e.target.value)}
                                        className="form-select"
                                    >
                                        <option value="">Todas</option>
                                        {cuentasBancarias.map((cuenta) => (
                                            <option key={cuenta.idCatCuentaBancaria} value={cuenta.idCatCuentaBancaria}>
                                                {cuenta.vNumCta} - {cuenta.vNombreBanco} - {cuenta.vNombreTitular}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        </Card.Header>

                        <Card.Body className="p-0">
                            {cargando ? (
                                <div className="p-4">
                                    {[...Array(5)].map((_, index) => (
                                        <Card key={index} className="mb-3">
                                            <Card.Body>
                                                <Row>
                                                    <Col xs={12} md={2}>
                                                        <Skeleton height={30} width={80} className="mb-2" />
                                                        <Skeleton height={15} width={60} />
                                                    </Col>
                                                    <Col xs={12} md={6}>
                                                        <Skeleton height={20} className="mb-2" />
                                                        <Skeleton height={15} width={200} />
                                                        <Skeleton height={15} width={150} />
                                                    </Col>
                                                    <Col xs={12} md={4} className="text-end">
                                                        <Skeleton height={25} width={100} className="mb-2" />
                                                        <Skeleton height={20} width={60} />
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    ))}

                                    {/* Mostrar skeleton para el trigger de infinite scroll */}
                                    <div className="text-center py-4">
                                        <Spinner animation="border" variant="primary" className="mb-2" />
                                        <div className="text-muted small">Cargando m&aacute;s gastos...</div>
                                    </div>
                                </div>
                            ) : gastos.length > 0 ? (
                                <div className="p-3">
                                    <Row className="mb-3 text-muted align-items-center">
                                        <Col>
                                            <small>
                                                Mostrando {gastos.length} de {totalRecords} gastos
                                                {busqueda && ` para "${busqueda}"`}
                                            </small>
                                            {gastosSeleccionados.length > 0 && (
                                                <small className="text-primary fw-bold ms-3">
                                                    {gastosSeleccionados.length} gasto{gastosSeleccionados.length !== 1 ? 's' : ''} seleccionado{gastosSeleccionados.length !== 1 ? 's' : ''}
                                                </small>
                                            )}
                                        </Col>
                                        <Col xs="auto" className="text-end">
                                            <div className="text-primary fw-bold">
                                                Total: {totalSum.toLocaleString("es-MX", { style: "currency", currency: "MXN" })}
                                            </div>
                                        </Col>
                                    </Row>
                                    {gastos.map((gasto) => (
                                        <GastoCard
                                            key={gasto.idGasto}
                                            gasto={gasto}
                                            isSelected={gastosSeleccionados.includes(gasto.idGasto)}
                                            onToggleSelection={toggleSeleccionGasto}
                                            onView={handleViewGasto}
                                            onEdit={handleEditGasto}
                                            onCopy={handleCopyGasto}
                                            getFormaPagoIcon={getFormaPagoIcon}
                                            onDescargarNota={handleDescargarNotaVenta}
                                        />
                                    ))}
                                    <InfiniteScrollTrigger />
                                </div>
                            ) : (
                                <div className="text-center py-5">
                                    <div className="mb-3">
                                        <FontAwesomeIcon
                                            icon={icon({ name: 'receipt', style: "solid" })}
                                            size="3x"
                                            className="text-muted"
                                        />
                                    </div>
                                    <h5 className="text-muted">No se encontraron gastos</h5>
                                    <p className="text-muted">
                                        {busqueda
                                            ? `No hay gastos que coincidan con "${busqueda}"`
                                            : 'No hay gastos registrados para el perIodo seleccionado'
                                        }
                                    </p>
                                    {!busqueda && (
                                        <Button
                                            variant="primary"
                                            onClick={() => {
                                                setShowModalRegistrarGasto(true);
                                                setShowModalNuevo(true);
                                            }
                                            }
                                        >
                                            <FontAwesomeIcon icon={icon({ name: 'plus', style: "solid" })} className="me-1" />
                                            Registrar primer gasto
                                        </Button>
                                    )}
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {showModalRegistrarGasto && (
                <ModalRegistroGastoRefactor
                    gastos={gastos}
                    setGastos={setGastos}
                    showModalRegistrarGasto={showModalRegistrarGasto}
                    setShowModalRegistrarGasto={setShowModalRegistrarGasto}
                    showModalNuevo={showModalNuevo}
                    setShowModalNuevo={setShowModalNuevo}
                    selectedGasto={selectedGasto}
                    setSelectedGasto={setSelectedGasto}
                    ultimoGasto={ultimoGasto}
                    setUltimoGasto={setUltimoGasto}
                    copia={copia}
                    setCopia={setCopia}
                    Editar={Editar}
                    setEditar={setEditar}
                />
            )}

            {showVisualizarModal && (
                <ModalVisualizarDetallesGasto
                    show={showVisualizarModal}
                    selectedGasto={selectedGasto}
                    onClose={() => setShowVisualizarModal(false)}
                />
            )}

            {/* Modal de descarga de nota de venta */}
            <ModalDescargaNotaVenta show={showDescargaModal} />
        </>
    );
};

ListaGastos.propTypes = {

    setShowModalNuevo: PropTypes.func,
    showModalNuevo: PropTypes.bool,

    setShowModalRegistrarGasto: PropTypes.func,
    showModalRegistrarGasto: PropTypes.bool

};


export default ListaGastos;